// src/components/ActiveSwarmList.js

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import ActiveSwarmCard from "./activeSwarmCard/ActiveSwarmCard";
import { useSelector } from 'react-redux';
import { selectSortOption } from '../../../../../store/slices/swarmsInAction';

const sortSwarms = (swarms, sortOption) => {
  switch (sortOption) {
    case 'highestReward':
      return [...swarms].sort((a, b) => b.reward - a.reward);
    case 'dateTime':
      return [...swarms].sort((a, b) => new Date(a.event.date) - new Date(b.event.date));
    case 'performerName':
      return [...swarms].sort((a, b) => a.event.name.localeCompare(b.event.name));
    case 'bteId':
    default:
      return [...swarms].sort((a, b) => a.bteId - b.bteId);
  }
};

export default function ActiveSwarmList({ swarms }) {
  const sortOption = useSelector(selectSortOption);
  const sortedSwarms = sortSwarms(swarms, sortOption);

  return (
    <Grid 
      container 
      spacing={0.75} // Adjusts the space between Grid items
      justifyContent="flex-start" // Aligns items to the start of the container
    >
      {sortedSwarms.map((swarm) => (
        <Grid 
          item 
          key={swarm.id} 
        >
          {(swarm && swarm.event) && <ActiveSwarmCard swarm={swarm} />}
        </Grid>
      ))}
    </Grid>
  );
}

ActiveSwarmList.propTypes = {
  swarms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};
